module.exports = __webpack_public_path__ + "media/poll.5a7dd184.webm";